export const PERMISSION_RESOURCE_CODES = {
  permission: 'permission',
  check: 'check',
  dashboard: 'dashboard',
  inventory: 'inventory',
  material: 'material',
  purchase: 'purchase',
  receive: 'receive',
  rule: 'rule',
  supplier: 'supplier',
  statistics: 'statistics',
  warehouse: 'warehouse',
  workflow: 'workflow',
  // 绿植模块
  greenplantDashboard: 'greenplant-dashboard',
  assets: 'greenplant-assets',
  tasks: 'greenplant-tasks',
  issues: 'greenplant-issues',
  insights: 'greenplant-insights',
  settings: 'greenplant-settings',
  dataScopes: 'greenplant-data-scopes',
} as const;

export const PERMISSION_ACTION_CODES = {
  permission: {},
  greenplantDashboard: {},
  assets: {
    create: 'create',
    update: 'update',
    remove: 'remove',
  },
  tasks: {
    create: 'create',
    execute: 'execute',
    defer: 'defer',
  },
  issues: {
    create: 'create',
    assign: 'assign',
    resolve: 'resolve',
    close: 'close',
    reopen: 'reopen',
  },
  insights: {},
  settings: {
    manage: 'manage',
  },
  dataScopes: {
    manage: 'manage',
  },
  check: {
    view: 'view',
    add: 'add',
    execute: 'execute',
    approve: 'approve',
    cancel: 'cancel',
    reopen: 'reopen',
  },
  dashboard: {
    view: 'view',
  },
  inventory: {
    view: 'view',
    adjust: 'adjust',
    approveAdjustment: 'approveAdjustment',
    freeze: 'freeze',
    transfer: 'transfer',
    transferOutbound: 'transferOutbound',
    transferInbound: 'transferInbound',
    cancelTransfer: 'cancelTransfer',
    export: 'export',
  },
  material: {
    view: 'view',
    add: 'add',
    update: 'update',
    disable: 'disable',
  },
  purchase: {
    view: 'view',
    add: 'add',
    approve: 'approve',
    order: 'order',
    receive: 'receive',
    cancelOrder: 'cancelOrder',
    closeOrder: 'closeOrder',
    cancelReceipt: 'cancelReceipt',
    exception: 'exception',
    handleException: 'handleException',
  },
  receive: {
    view: 'view',
    add: 'add',
    update: 'update',
    submit: 'submit',
    withdraw: 'withdraw',
    copy: 'copy',
    issue: 'issue',
    approve: 'approve',
    return: 'return',
    confirmReturn: 'confirmReturn',
    cancelReturn: 'cancelReturn',
  },
  rule: {
    view: 'view',
    update: 'update',
    publish: 'publish',
    simulate: 'simulate',
  },
  supplier: {
    view: 'view',
    add: 'add',
    update: 'update',
    disable: 'disable',
    evaluate: 'evaluate',
  },
  statistics: {
    view: 'view',
    export: 'export',
  },
  warehouse: {
    view: 'view',
    add: 'add',
    update: 'update',
    disable: 'disable',
  },
  workflow: {
    view: 'view',
    approve: 'approve',
    transfer: 'transfer',
    terminate: 'terminate',
    markOverdue: 'markOverdue',
  },
} as const;

export const buildPermissionActionKey = (resourceCode: string, actionCode: string) =>
  `${resourceCode}:${actionCode}`;

export const ALL_PERMISSION_KEYS = [
  PERMISSION_RESOURCE_CODES.permission,
] as const;

export const permissionKey = (resource: string, action?: string) =>
  action ? `${resource}:${action}` : resource;

export const MEETING_ROOM_PERMISSION_RESOURCE = {
  dashboard: 'meeting-room-dashboard',
  rooms: 'meeting-room-rooms',
  bookings: 'meeting-room-bookings',
  minutes: 'meeting-room-minutes',
  reports: 'meeting-room-reports',
  config: 'meeting-room-config',
} as const;

export const MEETING_ROOM_PERMISSION_ACTION = {
  create: 'create',
  update: 'update',
  delete: 'delete',
  approve: 'approve',
  cancel: 'cancel',
  checkIn: 'check-in',
  complete: 'complete',
  dispatch: 'dispatch',
  export: 'export',
  manage: 'manage',
} as const;
